// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

// ANTD
import Popconfirm from 'antd/lib/popconfirm';
import Button from 'antd/lib/button';
import notification from 'antd/lib/notification';

// APOLLO
import { graphql, compose } from 'react-apollo';
import getClientsQuery from 'ApolloClient/Queries/getClients';
import deleteClient from 'ApolloClient/Mutations/deleteClient';

export class ClientDelete extends React.PureComponent {
  state = {
    disabled: false, // whether or not the form submit button is disabled
  };

  disableBtn = () => {
    this.setState({ disabled: true });
  };

  enableBtn = () => {
    this.setState({ disabled: false });
  };

  postMutationUpdate = (proxy, { data }) => {
    // will update local apollo cache after the mutation. see apollo docs.
    const localData = proxy.readQuery({
      query: getClientsQuery,
      variables: {},
    });
    // filter out the client we just deleted form the local apollo cache
    let newClients = localData.clients.filter(item => item._id !== data.deleteClient._id);
    // overwrite the apollo cache with filtered array
    proxy.writeQuery({
      query: getClientsQuery,
      data: {
        clients: newClients,
      },
    });
    this.props.history.push('/app/clients');
  };

  handleDelete = async () => {
    const { clientId, history, deleteClient } = this.props;

    this.disableBtn();

    const variables = { _id: clientId };

    try {
      await deleteClient({
        variables,
        update: this.postMutationUpdate,
      });
    } catch (exc) {
      console.log(exc);
      return notification.error({ message: exc });
    }

    notification.success({ message: 'Client successfully deleted!' });
    // Take the user back to client view.

    // window.location.reload();

    this.enableBtn();
  };

  render() {
    return (
      <div className="section-row">
        <div className="section-header">DANGER ZONE</div>
        <div className="my1" />
        <Popconfirm
          title="Are you sure you want to delete this client? This action can't be undone!"
          onConfirm={this.handleDelete}
          okText="Yes"
          cancelText="No"
        >
          <Button type="primary" className="block">
            DELETE CLIENT
          </Button>
        </Popconfirm>
      </div>
    );
  }
}

ClientDelete.propTypes = {
  clientId: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  deleteClient: PropTypes.func.isRequired,
};

const enhance = compose(
  withRouter, // provides access to history.push.
  graphql(deleteClient, { name: 'deleteClient' }), // provides access to deleteClient mutation.
);

export default enhance(ClientDelete);



// WEBPACK FOOTER //
// ./src/routes/app-client-detail/ClientDelete/index.js